import React from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si nunca toqué un mazo de tarot?',
    a: 'Sí, el Tomo 1 y 2 están diseñados para llevarte desde cero absoluto hasta comprender la estructura completa del mazo.'
  }, {
    q: '¿Con qué mazo de tarot funciona este material?',
    a: 'Está basado en el sistema Rider-Waite-Smith, que es el más recomendado para aprender, pero los conceptos aplican a cualquier mazo derivado de este sistema.'
  }, {
    q: '¿Enseña a adivinar el futuro?',
    a: 'Nuestro enfoque es evolutivo y terapéutico. Enseñamos a usar el tarot como una herramienta de autoconocimiento, proyección y guía, no de determinismo.'
  }, {
    q: '¿Sirve si ya sé leer las cartas?',
    a: 'Sí, es ideal para estructurar tu conocimiento, aprender nuevas tiradas complejas y profesionalizar tus sesiones.'
  }, {
    q: '¿Incluye un mazo físico de cartas?',
    a: 'NO. Este es un producto 100% digital. Son guías en PDF para aprender a leer, no incluye cartas físicas.'
  }, {
    q: '¿Es editable?',
    a: 'NO. Son archivos PDF cerrados, listos para usar e imprimir. No se pueden modificar en Word o Canva.'
  }, {
    q: '¿Puedo imprimir el material?',
    a: 'Sí, todo el material está diseñado en formato A4 para ser impreso fácilmente en tu casa o gráfica.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'De forma automática. Inmediatamente después de la compra, te llega un email con el link de descarga.'
  }, {
    q: '¿Incluye actualizaciones futuras?',
    a: 'NO. Comprás la versión completa y vigente al momento del pago. Es un pago único por el material actual.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 7 días de garantía. Si sentís que no es para vos, nos avisás y te devolvemos el dinero.'
  }];
  return <section className="px-4 py-12" data-id="element-97">
      <div className="max-w-3xl mx-auto" data-id="element-98">
        <h2 className="mb-8 text-3xl font-bold text-center md:text-4xl text-brand-teal" data-id="element-99">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-6" data-id="element-100">
          {faqs.map((faq, i) => <div key={i} className="p-6 border rounded-xl border-brand-teal/20 bg-[#1a1a1a]" data-id="element-101">
              <h3 className="mb-2 text-lg font-bold text-brand-teal" data-id="element-102">
                {faq.q}
              </h3>
              <p className="text-brand-dark/80" data-id="element-103">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}